import React from 'react';
import { Outlet } from 'react-router-dom';
import { Layout } from 'spark-core-dx/components';
import { ResourceDomainContextProvider } from './ResourceDomainProvider';

const ResourceDomain = ({ children }) => (
  <ResourceDomainContextProvider>
    <Layout layoutOverride="standard">
      {children ?? <Outlet />}
    </Layout>
  </ResourceDomainContextProvider>
);

export default ResourceDomain;
